import 'owl.carousel'

$(function () {

    $('.owl-carousel-categorias').owlCarousel({
        loop: true,
        margin: 20,
        autoplay: true,
        autoplayTimeout: 5000,
        responsiveClass: true,
        responsive: {
            0: {
                items: 3,
                nav: false,
                loop: true,
                autoplay: true,
            },
            400: {
                items: 3,
                nav: false,
                loop: true,
                autoplay: true,
            },
            768: {
                nav: false,
                loop: false,
                autoplay: false,
                autoWidth: true,
                items: 5,
            }
        }
    })

    $('.owl-carousel-novidades').owlCarousel({
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 8000,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1.5,
                nav: false,
            },
            900: {
                items: 4,
                nav: true,
            }
        }
    })

    $('.owl-carousel-produtos').owlCarousel({
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 8000,
        responsiveClass: true,
        responsive: {
            0: {
                items: 2.2,
                nav: false,
            },
            900: {
                items: 4,
                nav: true,
            }
        }
    })

    $('.owl-carousel-produtos2').owlCarousel({
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 8000,
        responsiveClass: true,
        responsive: {
            0: {
                items: 2.2,
                nav: false,
            },
            900: {
                items: 4,
                nav: true,
            }
        }
    })

    $('.owl-carousel-blogs').owlCarousel({
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 8000,
        responsiveClass: true,
        nav: true,
        responsive: {
            0: {
                items: 1.5,
                nav: false,
            },
            900: {
                items: 4,
            }
        }
    })

    $('.owl-carousel-mini-banner').owlCarousel({
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 5000,
        responsiveClass: true,
        responsive: {
            0: {
                items: 2,
                nav: false,
            },
            900: {
                items: 3,
                nav: true,
            }
        }
    })

    $('.owl-carousel-related').owlCarousel({
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 5000,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1.5,
                nav: false,
            },
            900: {
                items: 4,
                nav: true,
            }
        }
    })
})
